import React from "react";
import styles from "./SearchFilters.module.css";
import { Stack } from "@bookingcom/bui-react";
import { StopsFilterMobile } from "./FiltersSplit/StopsFilter";
import { AirlinesFilterMobile } from "./FiltersSplit/AirlinesFilter";
import { FlightTimesFilterMobile } from "./FiltersSplit/FlightTimesFilter";
import { DurationFilter } from "./FiltersSplit/DurationFilter";
import { BudgetPerAdultFilter } from "./FiltersSplit/BudgetPerAdultFilter";
import { useGetAvailableFilters } from "../SearchResults/components/boundsFilterHooks";
import FlexibilityFilter from "./Filters/FlexibilityFilter";
import AirportsFilter from "../../../components/elements/SearchFilters/FiltersSplit/AirportsFilter/AirportsFilter";
import {
  AppliedFilterChipsList,
  NewFiltersBaseViewportTracker
} from "../../../components/elements/SearchFilters/components";
import flights_web_budget_layover_airports_filters, {
  useTrackNewFilters
} from "../../../utils/experiments/funnel/flights_web_budget_layover_airports_filters";
import { WeekendTopFiltersMobile } from "./FiltersSplit/WeekendTopFilters";
import useFlightsWebWeekendTopFilter from "../../../utils/experiments/funnel/flights_web_weekend_top_filter";

const SearchFiltersMobile = () => {
  const availableFilters = useGetAvailableFilters();

  const { overlap } = useFlightsWebWeekendTopFilter();
  overlap();

  const addNewFilters = !!flights_web_budget_layover_airports_filters.trackWithDefaultStage();
  const isNewFilterAvailable =
    availableFilters.duration?.some((key) => key.durationType === "LAYOVER") ||
    Object.keys(availableFilters).some((key) => ["airports", "budgetPerAdult"].includes(key));
  useTrackNewFilters(isNewFilterAvailable);

  return (
    <div className={styles.contentWrapper} id="search_filters_content_wrapper">
      {Object.keys(availableFilters).length > 0 ? (
        <Stack gap={addNewFilters ? 4 : 8}>
          <WeekendTopFiltersMobile />
          <StopsFilterMobile />
          <AirlinesFilterMobile />
          <FlexibilityFilter />
          <FlightTimesFilterMobile />
          <DurationFilter />
          <NewFiltersBaseViewportTracker />
          {addNewFilters && (
            <>
              <BudgetPerAdultFilter />
              <AirportsFilter />
              <AppliedFilterChipsList />
            </>
          )}
        </Stack>
      ) : null}
    </div>
  );
};

export default SearchFiltersMobile;
